import * as actionTypes from "./sort.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET,
  });
};

export const setSort = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_SORT,
    payload: data,
  });
};
